import { Button } from './styles'
import { useTheme } from 'styled-components'
import Icon from '../../../../Icon'
import LeftChevronIcon from '../../../../../assets/icons/icon-cool/outline/Arrows-chevron/Left.svg'
import { useNavigate } from 'react-router-dom'

const Component = () => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } }
  const navigate = useNavigate();

  // This function is used to navigate to the home page
  // It will be called when the button is clicked
  const goBack = () => {
    navigate(-1);
  };


  return (
    <Button onClick={() => goBack()}>
      <Icon icon={LeftChevronIcon} size='16px' color={theme.colors.Black} />
    </Button>
  )
}

export default Component